import { Container } from 'inversify'
import EventEmitter from 'eventemitter3'
import { AppEventTypes } from '@/types/AppEventTypes'
import { LoggingService } from '@/services/LoggingService'

const container = new Container({
  autobind: true,
})

container
  .bind<LoggingService>('Logger')
  .toDynamicValue(() => new LoggingService())
  .inSingletonScope()

container
  .bind<EventEmitter<AppEventTypes>>('EventBus')
  .toDynamicValue(() => new EventEmitter<AppEventTypes>())
  .inSingletonScope()

export default container
